export default __webpack_public_path__ + "static/media/7.92738433.jpeg";